// Puerto del exportable de viajes del proveedor (LQ-1, ADR-026). La vista
// habla con esto y no con fetch: en los tests se reemplaza por un doble y en
// la app por http.ts.
//
// Recibe solo la planta: el proveedor lo resuelve la API desde la
// habilitacion activa de la empresa madre en cada request (ADR-015), y la
// query no acepta providerId. Sin montos (regla 7): metros, minutos y
// cantidades.
import type { TripExportResponse } from "@ucorp/contracts";
import type { PortalSession } from "../auth/session.js";

/** Dia operativo de hoy de la planta, en su zona IANA, tal como lo fija la API (regla 9). */
export interface OperationalToday {
  readonly date: string;
  readonly timezone: string;
}

export interface TripExportFile {
  readonly blob: Blob;
  readonly fileName: string;
}

export interface TripExportPort {
  /** Hoy en la planta: la fecha por defecto del selector. Nunca la del navegador. */
  today(session: PortalSession, siteId: string): Promise<OperationalToday>;
  /** Filas del periodo que contiene `date`. */
  read(session: PortalSession, siteId: string, date: string): Promise<TripExportResponse>;
  /** El mismo exportable en archivo. La API audita cada descarga. */
  download(session: PortalSession, siteId: string, date: string, format: "csv" | "xlsx"): Promise<TripExportFile>;
}

/**
 * Por que fallo una llamada, sin el cuerpo remoto: la UI elige el copy por
 * este codigo y nunca pinta el `detail` de la API.
 * - access: 403 (la empresa no tiene habilitacion activa en la planta).
 * - session: 401 (sesion vencida o rechazada).
 * - validation: 400 (fecha que la API no acepta).
 * - unavailable: 404, 5xx, red o respuesta que viola el contrato.
 */
export type TripExportErrorKind = "access" | "session" | "validation" | "unavailable";

export class TripExportError extends Error {
  constructor(readonly kind: TripExportErrorKind) {
    super(`trip_export_${kind}`);
  }
}
